import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { useSnackbar } from 'notistack';
import { CompaniesService } from 'api';
import {
  COMPANY_ZANBATO_PRICING_DEFAULT_ERROR_MESSAGE,
  COMPANY_ZANBATO_PRICING_QUERY_KEY,
} from 'common/constants/services/companies';

const useGetCompanyZanbatoPricing = (companyId: number | undefined) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading, isError } = useQuery({
    enabled: !isNil(companyId),
    queryFn: () => CompaniesService.apiCompaniesZanbatoPricingRead(companyId as number),
    queryKey: [COMPANY_ZANBATO_PRICING_QUERY_KEY, companyId],
    retry: false,
  });

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(COMPANY_ZANBATO_PRICING_DEFAULT_ERROR_MESSAGE, { variant: 'error' });
    }
  }, [isError, enqueueSnackbar]);

  return { data, isLoading, isError };
};

export default useGetCompanyZanbatoPricing;
